import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";

import discount_codes from "../../discount-code";

// Ambassador menu
export const AmbassadorSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'ambassador'
                ? <>
                    <MenuItemLink
                        to={`/discount/codes`}
                        primaryText={translate(`resources.discount_codes.name`)}
                        leftIcon={<discount_codes.icon />}
                        onClick={onMenuClick}
                    />
                </>
                : null
        )}
    >
    </WithPermissions>
)